import { useLayoutEffect, useState, useCallback } from "react"
import { debounce } from "lodash"

// https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
export default function useResizeObserver(ref, callback) {
  const [width, setWidth] = useState()
  const [height, setHeight] = useState()

  const handleResize = useCallback((entries) => {
    if (!Array.isArray(entries)) {
      return
    }

    const entry = entries[0]
    setWidth(entry.contentRect.width)
    setHeight(entry.contentRect.height)

    if (callback) {
      callback(entry.contentRect)
    }
  }, [callback])
  const debouncedResize = debounce(handleResize, 100)

  useLayoutEffect(() => {
    if (!ref || !ref.current) {
      return
    }

    let RO = new ResizeObserver((entries) =>
      debouncedResize(entries),
    )
    RO.observe(ref.current)

    return () => {
      RO.disconnect()
      RO = null
    }
  }, [debouncedResize, handleResize, ref])

  return [width, height]
}
